import { Grid } from '@mui/material';
import GridWrapper from 'src/shared/components/organisms/gridWrapper';
import MainContentHeader from 'src/shared/components/atoms/mainContentHeader';
import SendingGrid from 'src/modules/sending/components/sendingGrid';
import GridActionButtons from 'src/modules/sending/components/gridActionButtons';
import SendingTabs from 'src/modules/sending/components/sendingTabs';
import { useTranslation } from 'react-i18next';

export const AdminSendingOrderListPage = () => {
  const { t } = useTranslation();

  return (
    <GridWrapper>
      <Grid item xs={12} md={4} style={{ display: 'flex' }}>
        <MainContentHeader title={t('common:manageSendings')} />
      </Grid>
      <Grid item xs={12} md={8} style={{ display: 'flex', justifyContent: 'flex-end' }}>
        <GridActionButtons />
      </Grid>
      <Grid item xs={12}>
        <SendingTabs />
        <SendingGrid />
      </Grid>
    </GridWrapper>
  );
};
